import * as React from 'react';
import { Flex } from '../../designSystem/components/flex';

interface IDocumentLeftContainerProps {
    children: React.ReactNode;
    isAso?: boolean;
}

export const DocumentLeftContainer = (props: IDocumentLeftContainerProps) => (
    <Flex
        css={{ paddingTop: props.isAso ? '180px' : '73px', position: 'relative' }}
        direction="column"
        gap="5"
        width={props.isAso ? 157 : 178}
    >
        {props.children}
    </Flex>
);
